/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import Swiper, { Navigation, Lazy } from 'swiper';
import lozad from 'lozad';
import Plyr from 'plyr';

//import { tns } from "tiny-slider/src/tiny-slider";

// import then needed Font Awesome functionality
//import { config, library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
//import { faFacebook, faFacebookSquare, faTwitter, faTwitterSquare, faXing, faXingSquare, faLinkedin, faYoutubeSquare, faYoutube } from '@fortawesome/free-brands-svg-icons';
//import { faWarehouse, faAddressBook, faEnvelopeOpen, faEnvelope, faUser, faClock, faPhone, faCommentAlt, faDotCircle, faAt, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
// add the imported icons to the library
//config.searchPseudoElements = true;
//library.add(faFacebook, faFacebookSquare, faTwitter, faTwitterSquare, faXing, faXingSquare, faLinkedin, faWarehouse, faEnvelopeOpen, faEnvelope, faAddressBook, faUser, faClock, faPhone, faCommentAlt, faYoutubeSquare, faYoutube, faDotCircle, faAt, faSearch, faTimes );
// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
//dom.watch();

$(document).ready(() => {
  // console.log('Hello world');

  /** light mode dark mode code
    * Utility function to calculate the current theme setting.
    * Look for a local storage value.
    * Fall back to system setting.
    * Fall back to light mode.
    */
    function calculateSettingAsThemeString({ localStorageTheme, systemSettingDark }) {
      if (localStorageTheme !== null) {
        return localStorageTheme;
      }
      if (systemSettingDark.matches) {
        return "dark";
      }
      return "light";
    }
    /**
    * Utility function to update the button text and aria-label.
    */
    function updateButton({ buttonEl, isDark }) {
      const newCta = isDark ? "Change to light theme" : "Change to dark theme";
      // use an aria-label if you are omitting text on the button
      // and using a sun/moon icon, for example
      buttonEl.setAttribute("aria-label", newCta);
      // buttonEl.innerText = newCta;
    }
    /**
    * Utility function to update the theme setting on the html tag
    */
    function updateThemeOnHtmlEl({ theme }) {
      document.querySelector("html").setAttribute("data-theme", theme);
    }
    /**
    * On page load:
    */
    /**
    * 1. Grab what we need from the DOM and system settings on page load
    */
    const button = document.querySelector("[data-theme-toggle]");
    const localStorageTheme = localStorage.getItem("theme");
    const systemSettingDark = window.matchMedia("(prefers-color-scheme: dark)");
    /**
    * 2. Work out the current site settings
    */
    let currentThemeSetting = calculateSettingAsThemeString({ localStorageTheme, systemSettingDark });
    /**
    * 3. Update the theme setting and button text accoridng to current settings
    */
    updateButton({ buttonEl: button, isDark: currentThemeSetting === "dark" });
    updateThemeOnHtmlEl({ theme: currentThemeSetting });
    /**
    * 4. Add an event listener to toggle the theme
    */
    button.addEventListener("click", (event) => {
      const newTheme = currentThemeSetting === "dark" ? "light" : "dark";
      localStorage.setItem("theme", newTheme);
      updateButton({ buttonEl: button, isDark: newTheme === "dark" });
      updateThemeOnHtmlEl({ theme: newTheme });
      currentThemeSetting = newTheme;
    }); 
  // end dark light mode code

  //$('.links-header:nth-of-type(2)').hide();
  $(".links-header").eq(1).hide();
  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();

  /*function widthFunction(width) {
    if (width.matches) { // If media query matches
      console.log('Media Query Matched!')
      Typebot.initContainer("typebot-container", {
        publishId: "my-typebot-x1-lk38-dba",
        backgroundColor: "rgba(255,255, 255, 0)",
        customDomain: "chatbot.intermac.dev",
      });
    } else {
      var typebotCommands = Typebot.initBubble({
        publishId: "my-typebot-x1-lk38-dba",
        backgroundColor: "rgba(255,255, 255, 1)",
        customDomain: "chatbot.intermac.dev",
        button: { color: "#0042DA" },
     });
    }
  }
  
  var width = window.matchMedia("(min-width: 568px)")
  widthFunction(width) // Call listener function at run time
  width.addListener(widthFunction) // Attach listener function on state changes*/
  
  Swiper.use([Navigation, Lazy]);
  var swiper = new Swiper('.swiper-container', {
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      checkInView: true,
    },
    slidesPerView: 3,
    spaceBetween: 25,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    //<---Add this two lines in your code-->   
    observer: true,
    observeParents: true,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      300: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      // when window width is >= 480px
      768: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      // when window width is >= 640px
      992: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
      1400: {
        slidesPerView: 3,
        spaceBetween: 25,
      }
      },
  });

  var swiper2 = new Swiper('.swiper-fachartikel', {
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      checkInView: true,
    },
    slidesPerView: 3,
    spaceBetween: 25,
    navigation: {
      nextEl: '.swiper-fachartikel-next',
      prevEl: '.swiper-fachartikel-prev',
    },
    //<---Add this two lines in your code-->   
    observer: true,
    observeParents: true,
    // Disable drag/swipe on desktop
    allowTouchMove: !window.matchMedia('(hover: hover)').matches,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      300: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      // when window width is >= 480px
      768: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      // when window width is >= 640px
      992: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
      1400: {
        slidesPerView: 3,
        spaceBetween: 25,
      }
      },
  });

  var swiper3 = new Swiper('.swiper-container-2', {
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      checkInView: true,
    },
    slidesPerView: 2,
    spaceBetween: 25,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    //<---Add this two lines in your code-->   
    observer: true,
    observeParents: true,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      300: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      // when window width is >= 480px
      768: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      // when window width is >= 640px
      992: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      1400: {
        slidesPerView: 2,
        spaceBetween: 25,
      }
      },
  });

  var swiper4 = new Swiper('.swiper-materials', {
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      checkInView: true,
    },
    slidesPerView: 4,
    spaceBetween: 25,
    navigation: {
      nextEl: '.swiper-materials-next',
      prevEl: '.swiper-materials-prev',
    },
      //<---Add this two lines in your code-->   
    observer: true,
    observeParents: true,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      300: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      // when window width is >= 480px
      768: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      // when window width is >= 640px
      992: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: 25,
      }
      },
  });

  var swiper5 = new Swiper('.swiper-videos', {
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      checkInView: true,
    },
    slidesPerView: 3,
    spaceBetween: 25,
    navigation: {
      nextEl: '.swiper-videos-next',
      prevEl: '.swiper-videos-prev',
    },
      //<---Add this two lines in your code-->   
    observer: true,
    observeParents: true,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      300: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      // when window width is >= 480px
      768: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      // when window width is >= 640px
      992: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
      1400: {
        slidesPerView: 3,
        spaceBetween: 25,
      }
      },
  });

  var swiper6 = new Swiper('.swiper-messen', {
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      checkInView: true,
    },
    slidesPerView: 3,
    spaceBetween: 25,
    navigation: {
      nextEl: '.swiper-messen-next',
      prevEl: '.swiper-messen-prev',
    },
      //<---Add this two lines in your code-->   
    observer: true,
    observeParents: true,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      300: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      // when window width is >= 480px
      768: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      // when window width is >= 640px
      992: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
      1400: {
        slidesPerView: 3,
        spaceBetween: 25,
      }
      },
  });

  var swiper7 = new Swiper('.swiper-produkte', {
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      checkInView: true,
    },
    slidesPerView: 4,
    spaceBetween: 25,
    navigation: {
      nextEl: '.swiper-produkte-next',
      prevEl: '.swiper-produkte-prev',
    },
      //<---Add this two lines in your code-->   
    observer: true,
    observeParents: true,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      300: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      // when window width is >= 480px
      768: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      // when window width is >= 640px
      992: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: 25,
      }
      },
  });

  var swiper8 = new Swiper('.swiper-produkte-2', {
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      checkInView: true,
    },
    slidesPerView: 4,
    spaceBetween: 25,
    navigation: {
      nextEl: '.swiper-button-next-2',
      prevEl: '.swiper-button-prev-2',
    },
      //<---Add this two lines in your code-->   
    observer: true,
    observeParents: true,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      300: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      // when window width is >= 480px
      768: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      // when window width is >= 640px
      992: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: 25,
      }
      },
  });

  var swiper9 = new Swiper('#owl-messen', {
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      checkInView: true,
    },
    slidesPerView: 4,
    spaceBetween: 25,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
      //<---Add this two lines in your code-->   
    observer: true,
    observeParents: true,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      300: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      // when window width is >= 480px
      768: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      // when window width is >= 640px
      992: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: 25,
      }
      },
  });

  var swiper10 = new Swiper('.swiper-imagegallery', {
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      checkInView: true
    },
    slidesPerView: 3,
    spaceBetween: 25,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
      //<---Add this two lines in your code-->   
    observer: true,
    loop: true,
    observeParents: true,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      300: {
        slidesPerView: 1,
        spaceBetween: 25
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      // when window width is >= 480px
      768: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      // when window width is >= 640px
      992: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      1400: {
        slidesPerView: 3,
        spaceBetween: 25,
      }
      },
  });

  var swiper11 = new Swiper('.swiper-market-units', {
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      checkInView: true,
    },
    slidesPerView: 4,
    spaceBetween: 25,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
      //<---Add this two lines in your code-->   
    observer: true,
    observeParents: true,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      300: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      // when window width is >= 480px
      768: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      // when window width is >= 640px
      992: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: 25,
      }
      },
  });

  $('[data-bs-toggle="tooltip"]').tooltip();

  $('button.fa-university').click(function(e) {
    e.preventDefault()
    $(this).tab('show')
  })

  /*document.querySelector(".search-icon svg").addEventListener("click", () => {
    const div = document.querySelector(".ajaxsearchpro");
    div.style.display = "";
    setTimeout(() => div.style.display = "none", 8000); // 8000ms = 8s
  });*/
  const buttontimes = document.querySelector('.fa-search');
  const buttonsearch = document.querySelector('.fa-close');
  const search = document.querySelector('.ajaxsearchpro');
  const input = document.querySelector('input[type="search"]');
  /*const listgrid = document.querySelector('.blog-posts')
  const list = document.querySelector('button.list');
  const grid = document.querySelector('button.grid');  

  grid.addEventListener('click', () => {
    listgrid.classList.toggle('list');
    list.classList.add('active');
    list.classList.remove('active');
  });

  list.addEventListener('click', () => {
    listgrid.classList.toggle('grid');
    grid.classList.add('active');
    grid.classList.remove('active');
  });*/

  $('.list-grid').on('click', 'button', function(e) {
      $('.list-grid button').on('click',function(){
      $('button').removeClass('active');
      $(this).addClass('active');
    });
    if ($(this).hasClass('grid')) {
      $('.blog-posts').removeClass('list').addClass('grid');
    }
    else if($(this).hasClass('list')) {
      $('.blog-posts').removeClass('grid').addClass('list');
    }
  });

  buttonsearch.addEventListener('click', () => {
    search.classList.toggle('show');
    buttonsearch.classList.toggle('show');
    buttontimes.classList.toggle('hide');    
    input.focus();
  });

  buttontimes.addEventListener('click', () => {
    search.classList.toggle('show');
    buttonsearch.classList.toggle('show');
    buttontimes.classList.toggle('hide'); 
    input.focus();
  });

  //Toggle menu animation
  const menu = document.querySelector('.navbar-toggler');
  menu.addEventListener('click', () => {
    menu.classList.toggle('open');
  });

  autoPlayYouTubeModal();
  //Youtube Modal
  function autoPlayYouTubeModal() {
    var triggerOpen = $("body").find('[data-tagVideo]');
    triggerOpen.click(function() {
      var theModal = $(this).data("bs-target"),
        videoSRC = $(this).attr("data-tagVideo"),
        videoSRCauto = videoSRC + "?autoplay=1";
      $(theModal + ' iframe').attr('src', videoSRCauto);
      $(theModal + ' button.btn-close').click(function() {
        $(theModal + ' iframe').attr('src', videoSRC);
      });
    });
  }

  //audio player 
  // const player = new Plyr('audio', {controls: ['play', 'progress', 'current-time']});
  const players = Array.from(document.querySelectorAll('.js-player')).map(p => new Plyr(p, {controls: ['play', 'progress', 'current-time']}));
// Keep track of the active player
let activePlayer = null;

// Initialize Plyr for all audio players in the swiper slider
const playersfrontpage = Array.from(document.querySelectorAll('.js-player-fontpage')).map(p => {
  const player = new Plyr(p, { controls: ['play'] });

  // Add event listeners for play and pause events
  player.on('play', () => {
    if (activePlayer && activePlayer !== player) {
      activePlayer.pause();
    }
    activePlayer = player;
  });

  player.on('pause', () => {
    if (activePlayer === player) {
      activePlayer = null;
    }
  });

  return player;
});
  // const players = Plyr.setup('.js-player');

  /* Ajax call for category filtering
  https://discourse.roots.io/t/ajax-posts-by-category/14168/3
  $("#blog-cat-menu").change(function() {
    $.ajax({
      url: $(this).val(),
      type: 'POST',
      beforeSend: function() {
        $("body").addClass("ajax-sort");
      },
      success: function(got) {
        $(".blog-wrap").replaceWith($(got).find(".blog-wrap"));
        $(".title-template").replaceWith($(got).find(".title-template"));
        $("body").removeClass("ajax-sort");
      },
    });
  });*/

});
